import { inject, Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { StepDefinition, UserInvitationData, UserInvitationFlow } from '@core/tellent-types';

import { InvitationFlowStepService } from './invitation-flow-step.service';

@Injectable({
  providedIn: 'root',
})
export class InvitationFlowStateService {
  private readonly invitationDataSubject = new BehaviorSubject<Partial<UserInvitationData>>({});
  private readonly flowMap = inject(InvitationFlowStepService).flowStepMap;

  public readonly invitationData$ = this.invitationDataSubject.asObservable();

  private currentFlowType!: UserInvitationFlow;
  private currentStepIndex: number = 0;

  public initializeFlow(flowType: UserInvitationFlow): StepDefinition | null {
    this.currentFlowType = flowType;
    this.currentStepIndex = 0;
    this.invitationDataSubject.next({});

    return this.findNextValidStep();
  }

  public advanceFlow(stepData: Partial<UserInvitationData> | null): StepDefinition | null {
    if (stepData) {
      const currentData = this.invitationDataSubject.value;
      this.invitationDataSubject.next({ ...currentData, ...stepData });
    }

    this.currentStepIndex++;

    return this.findNextValidStep();
  }

  public finalizeFlow(): Observable<any> {
    const finalData = this.invitationDataSubject.value;
    // console.log('FINAL SUBMISSION:', finalData);

    return new Observable(observer => {
      observer.next({ success: true, ...finalData });
      observer.complete();
    });
  }

  private findNextValidStep(): StepDefinition | null {
    const flowMap = this.flowMap();
    const currentFlowSteps = flowMap[this.currentFlowType];
    if (!currentFlowSteps) return null;

    const data = this.invitationDataSubject.value;

    while (this.currentStepIndex < currentFlowSteps.length) {
      const stepDef = currentFlowSteps[this.currentStepIndex];

      if (stepDef.canMatch && !stepDef.canMatch(data)) {
        this.currentStepIndex++;
        continue;
      }

      return stepDef;
    }

    return null; // Signals flow completion
  }
}
